// A senior can book their sitting at the studio itself rather than their home
// school, in which case `orderPackage.schoolId` is 1075 -- the studio's own
// name/address, not the home school's, must be shown. Mirrors the server-side
// check in CampaignsGeneratorService#appointment_location.
export const STUDIO_SCHOOL_ID = 1075;
export const STUDIO_NAME = 'Shoob Studio';
export const STUDIO_STREET_ADDRESS = '4640 Spyres Way #1, Modesto, CA';
// Single-line form for the legacy (non-senior) layout, which has no separate name/address rows.
export const STUDIO_ADDRESS = `${STUDIO_NAME} ${STUDIO_STREET_ADDRESS}`;

// { name, address } to render on the senior appointment confirmation. Senior
// portrait shoots have a dedicated `seniorLocation` on the school (used when
// seniors are photographed at a different room/space than the rest of the
// school's appointments); falls back to the regular `scheduleLocation` when
// senior_location isn't set.
export function resolveSeniorAppointmentLocation(orderPackage) {
  if (orderPackage?.schoolId === STUDIO_SCHOOL_ID) {
    return { name: STUDIO_NAME, address: STUDIO_STREET_ADDRESS };
  }

  const school = orderPackage?.student?.school;
  return {
    name: school?.name,
    address: school?.seniorLocation || school?.scheduleLocation || '',
  };
}
